import $ from 'jquery';
import Flow from '../flow.js';
import notifications from './../notifications.js';
import config from './config.js';
import floatingLabels from './../floating-labels.js';
import signUpValidation from './signup-validation.js';
import utils from './../utils.js';
import { replace, push } from './../store/history.js';
import pesel from './pesel.js';
import BlockUi from './../utils/block-ui.js';
import Cookies from './../libs/tomcat-cookies.js';

let instance;

function Register() {
	let self = this;

	// Restore values saved during registration
	if (Cookies.get('registrationStepOne')) {
		const savedInfo = JSON.parse(Cookies.get('registrationStepOne'));
		document.getElementById('signup-username').value = savedInfo.username;
		document.getElementById('signup-email').value = savedInfo.email;
		document.getElementById('reg-password').value = savedInfo.password;
	}

	pesel.show()
		.then((shouldShow) => {
			const peselElement = document.getElementsByClassName('js-pesel')[0];
			if (shouldShow.result) {
				peselElement.classList.remove('u-hide');
			} else {
				peselElement.remove();
			}
		});
	const view = document.querySelector('.signup');
	this.container = $(view).closest('.js-bottom-wrapper').get(0);
	const changeHeaderWhenScroll = utils.debounce((event) => {
		if (event.target.scrollTop > 25) {
			$(view).find('.page-head').addClass('page-head--opac');
		} else {
			$(view).find('.page-head').removeClass('page-head--opac');
		}
	}, 100);

	Flow.call(this, view, config, {
		titleSelector: '.page-head__title',
		stepSelector: '.signup-step',
		openClass: 'u-show',
		openCallback() {
			this.container.classList.add('signup--open');
			this.toggle(this.container.querySelector('.log-in'), false);
		},
		closeCallback() {
			self = this;
			setTimeout(() => {
				self.container.classList.remove('menu--is-open', 'signup--open');
				self.view.classList.add('signup--is-not');
			}, 250);
		}
	});

	floatingLabels.setupPersistentLabels($(this.view).find('form'));
	signUpValidation.setupValidation($(this.view));
	signUpValidation.getInfoAndPopulateLists();

	$(this.view).find('.signup-step').scroll(changeHeaderWhenScroll);

	$(this.view).find('.signup-basic .btn').on('click.signupBasicValidate', (e) => {
		e.preventDefault();

		const blocker = new BlockUi(self.view.querySelector('.signup-basic form'));
		blocker.show();

		signUpValidation.validationsServerSideForStepOne(() => push('/register/details'), () => {
			console.error('step one fail');
		}, () => {
			blocker.destroy();
		});
	});

	$(this.view).find('.signup-details .btn').on('click.signupDetailValidate', (e) => {
		e.preventDefault();

		const blocker = new BlockUi(self.view.querySelector('.signup-details form'));
		blocker.show();

		signUpValidation.validationsServerSideForStepTwo(() => {
			notifications.hideNotification();
			signUpValidation.resetRegisterForm();
		}, () => {
			console.error('step two fail');
			// TODO Login the user (change icons and populate account menu) get user info with sessionKey
		}, () => {
			blocker.destroy();
		});

		//Remove the values saved during registration.
		if (Cookies.get('registrationStepTwo')) {
			Cookies.remove('registrationStepTwo');
		}
		if (Cookies.get('registrationStepOne')) {
			Cookies.remove('registrationStepOne');
		}
	});

	$(this.view).find('.header-icon--login').on('click.openLogin', () => {
		self.close();
		setTimeout(() => {
			replace('/login');
		}, 1000);
	});
}

Register.prototype = Object.create(Flow.prototype);
Register.prototype.constructor = Register;

function get() {
	if (!(instance instanceof Register)) {
		instance = new Register();
	}
	return instance;
}

export default get;



// WEBPACK FOOTER //
// ./mobile-core/src/register/register.js